/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import {
    filterEventsWithPlaylist,
    buildFilters,
} from "../../util/playlistStore"

const forceGoodEvent = (
    teamName,
    gameId,
    playlistId,
    en,
    game,
    history,
    playlistState
) => {
    let enp = en.split(":")
    let eventNumber = parseInt(enp[0], 10)
    let camera = "tracecam"
    if (enp.length > 0) {
        camera = enp[1]
    }
    let fallbackEventNumber = undefined
    // console.log("forceGoodEvent", "eventNumber", eventNumber)
    // console.log("forceGoodEvent", "camera", camera)

    let selectedCamera = playlistState.selectedCamera
    let sportType = playlistState.sportType
    let selectedHalf = playlistState.selectedHalf
    let selectedInning = playlistState.selectedInning
    let selectedBaseballSide = playlistState.selectedBaseballSide
    let selectedBaseballTag = playlistState.selectedBaseballTag
    let selectedOrder = playlistState.selectedOrder

    // force clean urls
    let origUrl = window.location.hash.replace("#/", "/")
    let cleanUrl = origUrl.replace(/\?.*$/gi, "")

    // Do link resolving
    if (playlistId === "go") {
        let ok = goAndResolveTheUrl(teamName, gameId, game, history)
        if (ok) {
            return
        }
    }

    let playlist = game.playlists.find((p) => p.id === playlistId)

    let eventInPlaylist = false
    let playlistEvents = filterEventsWithPlaylist(
        playlist,
        game.events,
        buildFilters({
            selectedHalf,
            selectedInning,
            selectedBaseballSide,
            selectedBaseballTag,
            selectedCamera,
        }),
        selectedOrder
    )

    // update event number from keywords
    if (en === "first" && playlistEvents.length > 0) {
        eventNumber = playlistEvents[0].event_number
    }
    if (en === "last" && playlistEvents.length > 0) {
        eventNumber = playlistEvents[playlistEvents.length - 1].event_number
    }

    let gameClipId = null
    if (/^C/gi.test(`${en}`)) {
        let val = `${en}`.replace(/^C/gi, "")
        gameClipId = parseInt(val, 10)
    }
    for (let event of playlistEvents) {
        // eslint-disable-next-line eqeqeq
        if (eventNumber == event.event_number) {
            eventInPlaylist = true
            break
        }
        // eslint-disable-next-line eqeqeq
        if (gameClipId == event.game_clip_id) {
            eventInPlaylist = true
            break
        }

        if (!fallbackEventNumber && event.event_number > eventNumber) {
            fallbackEventNumber = event.event_number
        }
    }

    // event is in playlist no need to do anything else
    if (playlist && eventInPlaylist) {
        return
    }

    if (playlistId === "uuid") {
        return
    }

    // try to keep current playlist
    let canUsePlaylist = playlistEvents.length > 0 && playlist
    if (canUsePlaylist && playlist) {
        // fallback to current playst with different event
        let cleanParts = cleanUrl.split("/")
        cleanParts[5] = playlistEvents[0].event_number
        if (fallbackEventNumber) {
            cleanParts[5] = fallbackEventNumber
        }
        console.log(
            "forceGoodEvent redirect current playlist event 0",
            game,
            cleanParts.join("/"),
            gameClipId,
            playlistEvents,
            playlist
        )
        history.replace(cleanParts.join("/"))
        return
    }

    // find backup playlists and events
    let touchChainPlaylist = null
    let touchChainEvents = []

    let fullGamePlaylist = null
    let fullGameEvents = []

    for (let pl of game.playlists) {
        if (pl.id === "touch-chains") {
            touchChainPlaylist = pl
        }
        if (pl.id === "full-game") {
            fullGamePlaylist = pl
        }
        if (touchChainPlaylist && fullGamePlaylist) {
            break
        }
    }

    if (touchChainPlaylist) {
        touchChainEvents = filterEventsWithPlaylist(
            touchChainPlaylist,
            game.events
        )
    }

    if (fullGamePlaylist) {
        fullGameEvents = filterEventsWithPlaylist(fullGamePlaylist, game.events)
    }

    // decide what to do to rectify url and state

    if (touchChainEvents.length > 0) {
        // fallback to touch chain playlist
        let cleanParts = cleanUrl.split("/")
        cleanParts[4] = "touch-chains"
        cleanParts[5] = touchChainEvents[0].event_number
        history.replace(cleanParts.join("/"))
    } else if (fullGameEvents.length > 0) {
        // fallback to full game playlist
        console.log("forceGoodEvent redirect full game playlist event 0")
        let cleanParts = cleanUrl.split("/")
        cleanParts[4] = "full-game"
        cleanParts[5] = fullGameEvents[0].event_number
        history.replace(cleanParts.join("/"))
    } else {
        // cannot find any events, go back to team page
        console.log("forceGoodEvent redirect team page")
        history.replace(`/${teamName}`)
    }
}

const goAndResolveTheUrl = (teamName, gameId, game, history) => {
    let path = history.location.pathname
    let parts = path.split("/")
    let options = {}
    let lastPart = null
    for (let part of parts) {
        switch (lastPart) {
            case "type":
                options.type = part
                break
            case "half":
                options.half = part
                break
            case "time":
                options.time = part
                break
            default: {
                break
            }
        }
        lastPart = part
    }

    let events = game.events
    let playlistId = "all"
    if (options.type === "full-game") {
        events = events.filter((ev) => ev.meta.type === "FullGameVideo")
        playlistId = "full-game"
    }
    if (options.half) {
        // eslint-disable-next-line eqeqeq
        events = events.filter((ev) => ev.half == options.half)
    }
    if (options.time) {
        events = events.filter((ev) => {
            let start = ev.utc_time
            let end = ev.utc_time + ev.dynamic.duration * 1000

            if (start <= options.time && options.time < end) {
                return true
            }
            return false
        })
    }

    if (events.length > 0) {
        let event = events[0]
        let url = `/${teamName}/games/${gameId}/${playlistId}/${event.event_number}`

        if (options.time) {
            let tm = Math.round((options.time - event.utc_time) / 1000)
            url += `/time/${tm}`
        }
        console.log("ForceGoodEvent pushing url", url)

        history.push(url)
        return true
    }

    console.log("forceGoodEvent no changes")

    return false
}

export default forceGoodEvent
